"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealExplainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importDefault(require("react"));
const CommissionExplainer_styled_1 = require("./CommissionExplainer.styled");
const StyledDealPanel = (0, styled_1.default)(CommissionExplainer_styled_1.StyledCommissionPanel) `
	background-color: ${(props) => props.bgColor};
`;
const DEFAULT_DEAL_COLOUR = '#00B087';
const DealExplainer = (props) => {
    const { adjustmentAmount, bgColor, description } = props;
    const dealAmount = adjustmentAmount * 100;
    return react_1.default.createElement(StyledDealPanel, { bgColor: bgColor !== null && bgColor !== void 0 ? bgColor : DEFAULT_DEAL_COLOUR, "data-testid": 'deal-explainer-root' },
        react_1.default.createElement(CommissionExplainer_styled_1.CentredFlex, null,
            react_1.default.createElement(CommissionExplainer_styled_1.HeadingNumberSecondary, null,
                "\uD83C\uDF89 ",
                dealAmount,
                "%"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(CommissionExplainer_styled_1.ExplainerBody, null, description))));
};
exports.DealExplainer = DealExplainer;
//# sourceMappingURL=DealExplainer.js.map